import react from "react";
import Viewer from "../components/Viewer";
import { Machines } from "../graphql/querys/machines";
import { BackofficeWorkers } from "../graphql/querys/ backofficeWorkers";
export default function BackofficeUsersScreen() {
	return (
		<Viewer
			viewerInfo="backofficeWorkers"
			viewerQueryAll={BackofficeWorkers}></Viewer>
	);
}
